import React from "react";
import Button from "../../Button";
import FontAwesomeIcon from "../../Icon";
import { useDispatch } from "react-redux";

export const MobileDownloadIcon = ({ property: {mobileSyncAllowed, id}, onClick }) => {
  return (
    <Button 
      color="semantic"
      onClick={onClick}
    >
      <FontAwesomeIcon
        glyph="mobile" 
        style={{color: mobileSyncAllowed ?  'var(--color-teal)' : '#f00'}} 
        weight={mobileSyncAllowed ? "solid" : "light"}
      />
    </Button>
  );
}
